import { ActionType } from '../infrastructure/actionTypes';
import { IProductLogo } from '../infrastructure/interfaces';

export default (list:Array<IProductLogo> = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_PRODUCT_LOGOS_DONE:
      list = action.productLogosList;
      return [...action.productLogosList];

    case ActionType.UPDATE_PRODUCT_LOGO_DONE:
      list = list.map(d => {
        if (d.id.toUpperCase() !== action.logoData.id.toUpperCase()) {
            return d;
        }
        d.src = action.logoData.src;
        return d;
      });
      return list;
    
    case ActionType.ARCHIVE_PRODUCT_LOGO_DONE:
      const filteredList = list.filter(logo=> logo.id.toUpperCase() !== action.logo.id.toUpperCase());
      return filteredList;

    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/productLogosList.ts